import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { AboutUsComponent } from './about-us/about-us.component';
// import { MatchRmComponent } from './match-rm/match-rm.component';
// import { HelpSupportComponent } from './help-support/help-support.component';
// import { CareerComponent } from './career/career.component';
// import { HomeComponent } from './home/home.component';
// import { CustomerReviewComponent } from './customer-review/customer-review.component';
// import { AboutCeoComponent } from './about-ceo/about-ceo.component';
// import { IdentityComponent } from './identity/identity.component';
// import { HistoricalNavComponent } from './historical-nav/historical-nav.component';
import { InvestmentBankingComponent } from './investment-banking/investment-banking.component';
import { OtherValuationsComponent } from './other-valuations/other-valuations.component';
import { IpoComponent } from './ipo/ipo.component';
import { TrackRecordComponent } from './track-record/track-record.component';

const routes: Routes = [
  // {path:'home',component:HomeComponent},
  {path:'',component:InvestmentBankingComponent},
  {path:'home',component:InvestmentBankingComponent},
  {path: 'other-valuations', component: OtherValuationsComponent },
  {path: 'ipo', component: IpoComponent },
  {path: 'track-record', component: TrackRecordComponent },
   // {path:'home',component:HomeComponent},
  // {path:'about-us',component:AboutUsComponent},
  // {path:'rm-assistance',component:MatchRmComponent},
  // {path:'help-centre',component:HelpSupportComponent},
  // {path:'careers',component:CareerComponent},
  // {path:'customer-reviews',component:CustomerReviewComponent},
  // {path:'about-ceo',component:AboutCeoComponent},
  // {path:'identity',component:IdentityComponent},
  // {path:'historical-nav',component:HistoricalNavComponent},
  // {path:'investment-banking',component:InvestmentBankingComponent}
     { path: '**', redirectTo: 'home', pathMatch: 'full' } 
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
